// extracted by mini-css-extract-plugin
export default {"pageHeader":"pageHeader__EoacR","contextHolder":"contextHolder__iZc4F","context":"context__vLKSt","contextPage":"contextPage__xcPHV","elementsTable":"elementsTable__y7pXI"};